import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpDistributionSummaryPage } from '@/features/marketPromotion/pages/MpDistributionSummaryPage';
import { mpReportSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';

export const Route = createFileRoute('/_auth/market-promotion/distribution-summary')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.DISTRIBUTION_SUMMARY_VIEW),
  validateSearch: mpReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Distribution Summary">
      <Suspense fallback={<PageLoader />}>
        <MpDistributionSummaryPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
